import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Small helper hook to check if the viewport is below a given breakpoint.
 * Defaults to Material UI's "sm" to cover phone-sized screens.
 */
export default function useIsMobile(breakpoint = "sm") {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
}
